import { Routes } from '@angular/router';

export default <Routes>[
  // eslint-disable-next-line array-element-newline
  {
    path: '',
    loadComponent: async () => import('./components/profile-wrapper/profile-wrapper.component'),
    children: [
      { path: '', loadComponent: async () => import('./components/profile/profile.component') },
      { path: 'games', loadComponent: async () => import('./components/profile-games/profile-games.component') },
      { path: 'inventory', loadComponent: async () => import('./components/profile-inventory/profile-inventory.component') },
      { path: 'debug', loadComponent: async () => import('./components/debug/debug.component') },
      { path: ':id', loadComponent: async () => import('./components/other-profile/other-profile.component') }
    ]
  }
];
